<template>
  <div class="wlx-banner-manager-wrapper">
    <div class="add-partner-enterprise-head">
      <el-button
        size="small"
        type="primary"
        class="add-banner-btn"
        icon="el-icon-circle-plus-outline"
        @click="add"
      >添加</el-button>
      <el-button
        size="small"
        type="primary"
        class="delete-banner-btn"
        icon="el-icon-delete"
        @click="deleteAll"
      >删除</el-button>
    </div>
    <!-- 新增文档 -->
    <el-dialog
      title="新增文档"
      :visible.sync="addNewNoticeVisible"
      :before-close="cancel"
      :append-to-body="true"
      width="50%"
      :close-on-click-modal="false">
      <div>
        <el-form ref="ruleForm" label-width="120px">
          <!-- <el-form-item label="文档">
            <UploadWord
              :url="urlAliyunOSS"
              v-if="addNewNoticeVisible"
              :docId.sync="docId"
              :docUrl.sync="docUrl"
              :docTitle.sync="docTitle"
            ></UploadWord>
          </el-form-item> -->
          <el-form-item label="标题">
            <el-input v-model="title"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <Editor v-model="content" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="是否展示" prop="link">
            <el-form-item label="">
              <el-radio v-model="isShow" :label="1">是</el-radio>
              <el-radio v-model="isShow" :label="0">否</el-radio>
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addSchoolSlide()">确 定</el-button>
      </span>
    </el-dialog>
    <!--编辑-->
    <el-dialog
      title="编辑文档"
      :visible.sync="editNoticeVisible"
      :before-close="cancel"
      :append-to-body="true"
      width="50%"
      :close-on-click-modal="false">
      <div>
        <el-form ref="ruleForm" label-width="120px">
          <!-- <el-form-item label="文档">
            <UploadWord :url="urlAliyunOSS" :files.sync="files" :docId.sync="docId" :docUrl.sync="docUrl" :docTitle.sync="docTitle" v-if="addNewNoticeVisible"></UploadWord>
          </el-form-item> -->
          <el-form-item label="标题">
            <el-input v-model="title"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <Editor v-model="content" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="是否展示" prop="link">
            <el-form-item label="">
              <el-radio v-model="isShow" :label="1">是</el-radio>
              <el-radio v-model="isShow" :label="0">否</el-radio>
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="editSchoolSlide()">确 定</el-button>
      </span>
    </el-dialog>
    <div class="baner-table-main">
      <el-table
        ref="multipleeeeTable"
        :data="list"
        tooltip-effect="dark"
        empty-text=" "
        style="width: 100%;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="id" type="selection" width="55"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column prop="title" label="文档标题" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
        <el-table-column label="是否展示">
          <template slot-scope="scope">
            <span v-if="scope.row.isShow == 0">否</span>
            <span v-else-if="scope.row.isShow == 1">是</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
              <el-button
                size="mini"
                class="el-icon-edit"
                @click="edit(scope.row)"
                type="primary"
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
              <el-button
                size="mini"
                type="danger"
                class="el-icon-delete"
                @click="deleteMajor(scope.row.id)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="banner-page-con" v-show="total>0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="pageIndex"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <div v-if="noDataShow" class="yk-nodata-source-content">
      <img src="~assets/images/the-last-new-nodata-imag.png" alt class="yk-prompt">
      <!-- <div class="sp-noData" style="color:#000">暂无数据。</div> -->
    </div>
  </div>
</template>

<script>
import UploadWord from "components/UploadWord.vue";
import { type } from "os";
export default {
  props: {
    type: {
      type: Number,
      default: 2
    },
    certificateId:{
      type:String,
      default: ''
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      viewNoticeVisible: false,
      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      title: "",
      content:"",
      description: "",
      urlAliyunOSS: "/api/design/osssign/getsign",
      docUrl: "",
      docTitle: "",
      docId:"",
      link: "",
      wordId: "",
      /* --------------------------------------- */
      id: "",
      ids: [],
      noDataShow: false,
      loadingShow: false,
      tisi:"",
      isShow:0,
      files:[]
    };
  },
  components: {
    // loadingData,
    UploadWord
  },
  created() {
    this.getManagerWordList(1);
  },
  methods: {
    getManagerWordList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/ManagerWord/getManagerWordList", {
          type: this.type,
          certificateId:this.certificateId,
          page: page,
          pageSize: this.pageSize
        })
        .then(function(rst) {
          if (rst.code == 1) {
            that.list = rst.list;
            that.total = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.pageIndex = rst.pagination.pageIndex;
            that.cancel();
            if(that.list.length == 0){
              that.noDataShow = true;
            }
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    onPageChangeHandler(page) {
      this.getManagerWordList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getManagerWordList(1);
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.id);
      });
    },
    cancel() {
      this.addNewNoticeVisible = false;
      this.editNoticeVisible = false;
      this.viewNoticeVisible = false;
      // this.title = "";
      // this.description = "";
      this.docUrl = "";
      this.docId = "";
      this.docTitle="";
      this.isShow = "";
      this.wordId = "";
    },
    addSchoolSlide() {
      var that = this;
      this.$http
        .post("/api/XOrg/ManagerWord/addOrEditManagerWord", {
          isShow: this.isShow,
          title:this.title,
          Content:this.content,
          docTitle: this.docTitle,
          docUrl: this.docUrl,
          docId: this.docId,
          certificateId:this.certificateId
        })
        .then(function(rst) {
          if (rst.code === 1) {
            that.cancel();
            that.$message({
              showClose: true,
              message: rst.msg,
              type: "success"
            });
            that.getManagerWordList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    viewSchoolNews(row) {
      this.title = row.title;
      this.description = row.description;
      this.docUrl = row.cover;
      this.viewNoticeVisible = true;
    },
    editSchoolSlide() {
      var that = this;
      this.$http
        .post("/api/XOrg/ManagerWord/addOrEditManagerWord", {
          id: this.wordId,
          title:this.title,
          Content:this.content,
          docTitle: this.docTitle,
          docUrl: this.docUrl,
          docId: this.docId,
          isShow:this.isShow,
          certificateId:this.certificateId
        })
        .then(function(rst) {
          if (rst.code === 1) {
            that.cancel();
            that.$message.success(rst.msg);
            that.editNoticeVisible = false;
            that.getManagerWordList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    add() {
      this.docUrl = "";
      this.docId = "";
      // this.link = "";
      this.docTitle = "";
      this.wordId = "";
      this.isShow = ""
      this.addNewNoticeVisible = true;
    },
    edit(row) {
      this.editNoticeVisible = true;
      this.addNewNoticeVisible = true;
      this.title = row.title;
      this.content = row.content;
      this.docTitle = row.docTitle;
      this.docUrl = row.docUrl;
      this.docId = row.docId;
      this.isShow = row.isShow;
      this.wordId = row.id;
    },
    deleteMajor(id) {
      var that = this;
      this.$confirm("此操作将删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.$http
            .post("/api/XOrg/ManagerWord/deleteManagerWord", {
              ids: id
            })
            .then(function(rst) {
              if (rst.code === 1) {
                that.$message.success(rst.msg);
                that.getManagerWordList();
              }else{
                that.$message.warning(rst.msg);
              }
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getManagerWordList(1);
    },
    deleteAll() {
      var that = this;
      if (this.ids.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择文件",
          type: "warning"
        });
        return false;
      }
      this.$confirm("此操作将删除所选文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.$http
            .post("/api/XOrg/BannerManager/deleteBanner", {
              ids: that.ids
            })
            .then(function(rst) {
              if (rst.code === 1) {
                that.$message.success(rst.msg);
                that.getManagerWordList();
              }else{
                that.$message.warning(rst.msg);
              }
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-banner-manager-wrapper {
  .add-partner-enterprise-head {
    // position: fixed;
    // top: 60px;
    // right: 0;
    height: 60px;
    // width: calc(100% - 240px);
    // z-index: 1000;
    background: #fff;
    text-align: right;
    .add-banner-btn,
    .delete-banner-btn {
      margin-top: 13px;
    }
    .delete-banner-btn {
      margin-right: 62px;
    }
  }
  .baner-table-main {
    margin: 20px 0 0 30px;
  }
  .banner-page-con {
    padding: 20px 0;
    text-align: center;
  }
}
</style>

